<template>
  <div class="bulma">
    <footer class="footer">
      <div class="content has-text-centered">
        <p>
          <strong>TheAdmin</strong> by <a href="https://www.thecompagnie.eu">TheCompagnie</a>
        </p>
        <p>
          <small><a style="font-weight: 400;" href="https://theadmin.thecompagnie.eu">theadmin.thecompagnie.eu</a><br />Tous droits réservés © 2018</small>
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
import { contentsRef, routesRef } from '@/admin/firebase_config/index'
import contentFetch from '@/admin/mixins/contentFetch'

export default {
  name: 'app-foot',
  mixins: [contentFetch],
  components: {
  },
  firebase: {
    routes: routesRef,
    contents: contentsRef
  },
  data () {
    return {
      filter: {
        category: undefined,
        q: undefined
      }
    }
  },
  computed: {
    socials () {
      return this.getContentsByType('Socials')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/index.scss';

.footer{
  font-size: 0.8em;
  a{
    font-size: 1em;
  }
}
</style>



// WEBPACK FOOTER //
// src/app/components/appFoot.vue